'use client'

import { useEffect, useState, type RefObject } from 'react'

type SectionVisibilityOptions = {
  root?: RefObject<Element | null> | null
  rootMargin?: string
  threshold?: number | number[]
}

export function useSectionVisibility(
  elementRef: RefObject<Element | null>,
  options: SectionVisibilityOptions = {},
): boolean {
  const [isVisible, setIsVisible] = useState(false)
  const { root = null, rootMargin = '0px', threshold = 0.05 } = options

  useEffect(() => {
    const element = elementRef.current
    if (!element) return

    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { root: root?.current ?? null, rootMargin, threshold },
    )
    observer.observe(element)
    return () => observer.disconnect()
  }, [elementRef, root, rootMargin, threshold])

  return isVisible
}
